export { default } from './BorrowingQuota';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingQuota/index.js